export class UpdateBondRateParam {
    bankId: number;
    effectiveDate: string | Date;
    oldStandardRate: number;
    newStandardRate: number;
    oldFinancialGuaranteeRate: number;
    newFinancialGuaranteeRate: number;
    modifiedBy: string;
    dateModified: string | Date;
    constructor() {
        this.modifiedBy = 'BLC System';
        this.dateModified = new Date().toISOString();
    }
}